// import RoutingSales from './sales/script';
import RoutingCaseStudySlider from './case-study-slider/script';

export default {
	// [RoutingSales.selector]: RoutingSales
	[RoutingCaseStudySlider.selector]: RoutingCaseStudySlider
};
